var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 4.78842H9.83366V6.44227H8.16699V4.78842ZM8.16699 8.09612H9.83366V13.0577H8.16699V8.09612ZM9.00033 0.653809C4.40033 0.653809 0.666992 4.35842 0.666992 8.92304C0.666992 13.4877 4.40033 17.1923 9.00033 17.1923C13.6003 17.1923 17.3337 13.4877 17.3337 8.92304C17.3337 4.35842 13.6003 0.653809 9.00033 0.653809ZM9.00033 15.5384C5.32533 15.5384 2.33366 12.5698 2.33366 8.92304C2.33366 5.27631 5.32533 2.30765 9.00033 2.30765C12.6753 2.30765 15.667 5.27631 15.667 8.92304C15.667 12.5698 12.6753 15.5384 9.00033 15.5384Z",
    fill: "#0468b1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.717494c43210884900c4edae07329010.svg";
export { ForwardRef as ReactComponent };